import { cn } from 'components/utils';

import { spinnerGlyphRecipe } from './Spinner.recipe';

type Props = {
  className?: string;
};

/**
 * Figma's `CircleNotch`, the ring every loading surface draws: `Spinner`, a busy `Button` and a
 * loading `Tag`.
 *
 * SILENT, and internal on purpose: it is not exported from the barrel. It carries no name and no
 * role, so on its own it is a spinning decoration on a screen that says nothing is happening. Each
 * host supplies the announcement: `Spinner` is its own `role="status"`, a `Button` is `aria-busy`,
 * a `Tag` is `aria-busy` and its own text is what is read.
 *
 * The path is the vector exported straight out of the button set's own loading variant, on that
 * variant's 20x20 icon frame, so the arc, its sweep and its stroke caps are the file's rather than an
 * approximation of them. `fill` is an ATTRIBUTE on the path, which is what lets `currentColor` reach
 * it (a CSS rule on it would beat the attribute, and the same is true of every DS icon).
 *
 * It fills whatever box its host gives it; the host sets the size. Rotation and its reduced-motion
 * pulse live in `spinnerGlyphRecipe`.
 */
export const SpinnerGlyph = ({ className }: Props) => (
  <svg
    aria-hidden
    className={cn(spinnerGlyphRecipe(), className)}
    fill="none"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.84692 2.06326C6.94501 2.05959 7.04294 2.07562 7.13501 2.10965C7.22726 2.14381 7.31307 2.1954 7.38525 2.26223C7.45738 2.32908 7.51505 2.41093 7.55615 2.50027C7.59711 2.58953 7.62072 2.68657 7.62451 2.78469C7.62819 2.88269 7.61207 2.98078 7.57812 3.07278C7.54396 3.16502 7.49236 3.25085 7.42554 3.32302C7.3588 3.39503 7.27788 3.45283 7.18872 3.49392C4.79741 4.59198 3.24973 7.02293 3.24951 9.68777C3.24951 11.4778 3.96135 13.1949 5.22705 14.4607C6.49292 15.7266 8.20979 16.4383 10 16.4383C11.7902 16.4383 13.5071 15.7266 14.7729 14.4607C16.0386 13.1949 16.7505 11.4778 16.7505 9.68777C16.7503 7.02293 15.2038 4.59198 12.8125 3.49392C12.6322 3.41079 12.4909 3.25902 12.4219 3.07278C12.3532 2.88658 12.3611 2.68067 12.4438 2.50027C12.5269 2.31972 12.6786 2.17869 12.865 2.10965C13.0513 2.0408 13.2582 2.04874 13.4387 2.13162L13.4375 2.13284C16.3611 3.47452 18.2493 6.43669 18.2495 9.68777C18.2495 11.8757 17.3807 13.9744 15.8337 15.5215C14.2866 17.0687 12.188 17.9373 10 17.9373C7.81196 17.9373 5.71343 17.0687 4.16626 15.5215C2.61926 13.9744 1.75049 11.8757 1.75049 9.68777C1.7507 6.43689 3.63795 3.47342 6.56128 2.13162C6.65073 2.09055 6.74857 2.06699 6.84692 2.06326Z"
      fill="currentColor"
    />
  </svg>
);
